import * as React from 'react';

import { RequestDemandBlock } from '../../../components/RequestDemand/components/RequestDemandBlock';
import * as OfferCheck from '../../../components/RequestDemand/assets/offer-check-clear.png';
import { ILegalBanner } from './getBanner';
import { ElementInViewport } from '../../../common/components/elementInViewport';
import { trackLegalBannerClick } from '../../../components/demand/utils/tracking';

export interface ILegalSupportDemand {
  banner: ILegalBanner | null;
  lendingUrl: string;

  onShownInViewPort(visible: boolean): void;
}
export const LegalSupportDemand: React.FC<ILegalSupportDemand> = ({ banner, lendingUrl, onShownInViewPort }) => {
  const handleButtonClick = React.useCallback(() => {
    trackLegalBannerClick();
    window.open(`${lendingUrl}#${banner ? banner.landing_mark : ''}`, '_blank');
  }, [lendingUrl, banner]);

  const [hasBlockShown, setHasBlockShown] = React.useState(false);

  const handleShown = React.useCallback(() => {
    if (hasBlockShown) {
      return;
    }
    setHasBlockShown(true);
    onShownInViewPort(true);
  }, [hasBlockShown]);

  if (!banner) {
    return null;
  }

  return (
    <ElementInViewport onChange={handleShown}>
      <RequestDemandBlock
        text={banner.text}
        title={banner.title}
        buttonText="Узнать подробности"
        image={OfferCheck}
        buttonAction={handleButtonClick}
      />
    </ElementInViewport>
  );
};

LegalSupportDemand.displayName = 'LegalSupportDemand';
